const getRedirectURI = () => {
    if ( process.env.REACT_APP_LOCAL === '2' )
        return 'http://localhost:3001/slack-code';
    
    else {
        switch( process.env.REACT_APP_ENVIRONMENT ) {
            case 'dev':
                return process.env.REACT_APP_SLACK_REDIRECT_URI_DEV;
            case 'staging':
                return process.env.REACT_APP_SLACK_REDIRECT_URI_STAGING;
            case 'prod':
                return process.env.REACT_APP_SLACK_REDIRECT_URI_PROD;
        }
    }
    throw new Error('LOCAL or ENVIRONMENT variable error.') 
}


export default getRedirectURI